var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-arrow-up",attrs:{"aria-hidden":"true","tabindex":"-1","role":"presentation","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#fff","d":"M5.016,23.5l-1.516-1.617L16.001,8.5l12.5,13.383L26.992,23.5L16.001,11.742L5.016,23.5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }